"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAppLocksParams = exports.UpdateOrgLocksParams = exports.SendMFASMSResponse = exports.SendMFASMSParams = exports.SetUserMFAPreferenceResponse = exports.SetUserMFAPreferenceParams = exports.GetMFABackupCodesResponse = exports.DeleteMFAFactorResponse = exports.DeleteMFAFactorParams = exports.VerifyMFAFactorResponse = exports.VerifyMFAFactorParams = exports.RegisterSMSMFAFactorResponse = exports.RegisterSMSMFAFactorParams = exports.RegisterTOTPMFAFactorResponse = exports.UpdateUserParams = exports.ListUserMFAFactorsResponse = exports.CreateUserParams = exports.GetPreferredMFAFactorResponse = exports.GetSensitiveAccessTokenResponse = exports.GetSensitiveAccessTokenParams = exports.GiveUserAccessParams = exports.TokenResponse = exports.CompleteSignupParams = exports.UpdateInviteParams = exports.GetSignupUserResponse = exports.CreateDeveloperInviteParams = exports.StartSignupParams = exports.ListUserResponse = exports.ListUserParams = exports.ListUserInvitesResponse = exports.GetUserInvitesParams = exports.ListAppsResponse = exports.ListAppParams = exports.UpdateAppParams = exports.CreateAppParams = exports.ListOrgResponse = exports.ListOrgParams = exports.UpdateOrgBilling = exports.UpdateOrgParams = exports.CreateOrgParams = exports.ExtendAppTrialParams = exports.UpgradeAppParams = exports.DowngradeAppParams = exports.ListResponseMetaData = exports.SearchParams = exports.PaginationParams = exports.OperationResponse = exports.IDParam = void 0;
const source = __importStar(require("@journeyapps-platform/types-source-service"));
const codecs = __importStar(require("@journeyapps-platform/micro-codecs"));
const models = __importStar(require("./models"));
const t = __importStar(require("ts-codec"));
exports.IDParam = t.object({
    id: t.string
});
exports.OperationResponse = t.object({
    success: t.boolean
});
exports.PaginationParams = t.object({
    cursor: t.string.optional(),
    limit: t.number.optional()
});
exports.SearchParams = exports.PaginationParams.and(t.object({
    search: t.string
}));
exports.ListResponseMetaData = t.object({
    count: t.number,
    more: t.boolean,
    total: t.number,
    cursor: t.string
});
exports.DowngradeAppParams = t.object({
    app_id: t.string,
    trial_duration: t.number
});
exports.UpgradeAppParams = t.object({
    app_id: t.string
});
exports.ExtendAppTrialParams = t.object({
    app_id: t.string,
    trial_duration: t.number
});
exports.CreateOrgParams = t.object({
    name: t.string
});
exports.UpdateOrgParams = t.object({
    id: t.string,
    label: t.string.optional()
});
exports.UpdateOrgBilling = t.object({
    id: t.string,
    business_customer_code: t.string.optional(),
    business_customer_region: t.Enum(models.BUSINESS_REGION).optional()
});
exports.ListOrgParams = exports.PaginationParams.and(codecs.FilterProperties(models.OrganizationResource));
exports.ListOrgResponse = exports.ListResponseMetaData.and(t.object({
    objects: t.array(models.OrganizationResource)
}));
exports.CreateAppParams = t.object({
    name: t.string,
    org_id: t.string,
    default_region: t.string,
    vcs_mode: t.string,
    source: source.SourceMetadata,
    auth_scope_id: t.string.optional(),
    features: t.array(t.Enum(models.ProjectFeatureFlags)).optional(),
    trial: t.boolean.optional()
});
exports.UpdateAppParams = t.object({
    id: t.string,
    name: t.string.optional(),
    auth_scope_id: t.string.optional(),
    source: source.SourceMetadata.optional(),
    vcs_mode: t.Enum(models.VCS_MODE).optional()
});
exports.ListAppParams = exports.PaginationParams.and(codecs.FilterProperties(codecs.ResourceId.and(t.object({
    name: t.string,
    org_id: t.string,
    trial: t.boolean,
    locked: t.boolean
}))));
exports.ListAppsResponse = exports.ListResponseMetaData.and(t.object({
    objects: t.array(models.AppResource)
}));
exports.GetUserInvitesParams = exports.PaginationParams.and(codecs.FilterProperties(models.DeveloperInviteResource));
exports.ListUserInvitesResponse = exports.ListResponseMetaData.and(t.object({
    objects: t.array(models.DeveloperInviteResource)
}));
exports.ListUserParams = exports.PaginationParams.and(codecs.FilterProperties(models.UserResource));
exports.ListUserResponse = exports.ListResponseMetaData.and(t.object({
    objects: t.array(models.UserResource)
}));
exports.StartSignupParams = t.object({
    email: t.string,
    /**
     * When "start signup" is initiated for someone else (e.g. by an admin from override), this is the id of the creator.
     */
    user_id: t.string.optional(),
    features: t.array(t.Enum(models.ProjectFeatureFlags)).optional()
});
exports.CreateDeveloperInviteParams = t.object({
    email: t.string,
    org_id: t.string,
    requested_role_ids: t.array(t.string)
});
exports.GetSignupUserResponse = models.UserResource.and(t.object({
    onboarding_token: t.string.optional(),
    new_organization: t.boolean
}));
exports.UpdateInviteParams = t.object({
    id: t.string,
    requested_role_ids: t.array(t.string)
});
exports.CompleteSignupParams = t.object({
    id: t.string,
    name: t.string,
    phone_number: t.string.optional(),
    password: t.string,
    send_welcome_email: t.boolean.optional(),
    org_name: t.string.optional()
});
exports.TokenResponse = t.object({
    token: t.string
});
exports.GiveUserAccessParams = t.object({
    org_id: t.string,
    user_id: t.string,
    type: t.Enum(models.UserOrgAccess)
});
/**
 * Password is required if no MFA is active.
 * Factor ID and OTP is required if MFA is enabled for the user.
 */
exports.GetSensitiveAccessTokenParams = t.object({
    password: t.string.optional(),
    otp_attempt: t.string.optional(),
    factor_id: t.string.optional()
});
exports.GetSensitiveAccessTokenResponse = t.object({
    token: t.string
});
exports.GetPreferredMFAFactorResponse = t.object({
    factor: models.UserMFAFactorResource.optional()
});
exports.CreateUserParams = t.omit(models.User, ['signup_complete']);
exports.ListUserMFAFactorsResponse = t.object({
    factors: t.array(models.UserMFAFactorResource),
    backup_codes_viewed: t.boolean,
    preferred_factor_id: t.string.optional()
});
exports.UpdateUserParams = t.object({
    id: t.string,
    name: t.string.optional()
});
exports.RegisterTOTPMFAFactorResponse = t.object({
    factor: models.UserMFAFactorResource,
    factor_uri: t.string
});
exports.RegisterSMSMFAFactorParams = t.object({
    mobile_number: t.string,
    consented_at: codecs.date
});
exports.RegisterSMSMFAFactorResponse = t.object({
    factor: models.UserMFAFactorResource,
    factor_uri: t.string
});
exports.VerifyMFAFactorParams = t.object({
    factor_id: t.string,
    code: t.string
});
exports.VerifyMFAFactorResponse = t.object({
    success: t.boolean
});
exports.DeleteMFAFactorParams = t.object({
    factor_id: t.string
});
exports.DeleteMFAFactorResponse = t.object({
    success: t.boolean
});
exports.GetMFABackupCodesResponse = t.object({
    backup_codes: t.array(t.string)
});
exports.SetUserMFAPreferenceParams = t.object({
    factor_id: t.string
});
exports.SetUserMFAPreferenceResponse = t.object({
    factor: t.Enum(models.MFAFactor).optional()
});
exports.SendMFASMSParams = t.object({
    factor_id: t.string
});
exports.SendMFASMSResponse = t.object({
    sent: t.boolean
});
exports.UpdateOrgLocksParams = t.object({
    id: t.string,
    locked: t.boolean
});
exports.UpdateAppLocksParams = t.object({
    id: t.string,
    locked: t.boolean
});
